module.exports = __webpack_public_path__ + "static/media/snam.c55f038d.png";